/**
 * A single node of phoenix menu item.
 */
var PhoenixMenuNode = /** @class */ (function () {
    /**
     * Create the phoenix menu node.
     * @param name Name of the node.
     * @param icon Icon of the node.
     * @param onToggle Function on toggling the node.
     * @param children Children of the node.
     * @param configs Configuration options in the node.
     * @param parent Parent of the node.
     */
    function PhoenixMenuNode(name, icon, onToggle, children, configs, parent) {
        /** If the node toggle state is true or false. */
        this.toggleState = true;
        /** Children of the node. */
        this.children = [];
        /** Configuration options in the node. */
        this.configs = [];
        /** Level of the node. */
        this.nodeLevel = 0;
        /** If the node children are active or not. */
        this.childrenActive = false;
        /** If the node configuration options are active or not. */
        this.configActive = false;
        this.name = name;
        this.icon = icon;
        this.onToggle = onToggle;
        if (children)
            this.children = children;
        if (configs)
            this.configs = configs;
        if (parent)
            this.parent = parent;
    }
    /**
     * Add a child to the phoenix menu item.
     * @param name Name of the child.
     * @param onToggle Function on toggling the child.
     * @param icon Icon of the child.
     * @returns The child node.
     */
    PhoenixMenuNode.prototype.addChild = function (name, onToggle, icon) {
        var child = new PhoenixMenuNode(name, icon, onToggle);
        child.parent = this;
        child.nodeLevel = this.nodeLevel + 1;
        this.children.push(child);
        return child;
    };
    /**
     * Remove a child node.
     * @param child The child node to be removed.
     * @returns The current node.
     */
    PhoenixMenuNode.prototype.removeChild = function (child) {
        var childIndex = this.children.indexOf(child);
        this.children.splice(childIndex, 1);
        return this;
    };
    /**
     * Remove the current node.
     */
    PhoenixMenuNode.prototype.remove = function () {
        if (this.parent) {
            this.parent.removeChild(this);
        }
        else {
            console.error('Cannot delete root node of phoenix menu. Set it to undefined/null instead.');
        }
    };
    /**
     * Remove all children.
     */
    PhoenixMenuNode.prototype.truncate = function () {
        this.children = [];
    };
    /**
     * Add a config to the phoenix menu item.
     * @param options Options for the config.
     * @returns The current node.
     */
    PhoenixMenuNode.prototype.addConfig = function (type, options) {
        var configOptions = { type: type };
        Object.assign(configOptions, options);
        this.configs.push(configOptions);
        return this;
    };
    /**
     * Function for toggling the current and all child nodes.
     * @param value If the node itself and descendants are to be made true or false.
     */
    PhoenixMenuNode.prototype.toggleSelfAndDescendants = function (value) {
        var _a;
        (_a = this.onToggle) === null || _a === void 0 ? void 0 : _a.call(this, value);
        this.toggleState = value;
        for (var _i = 0, _b = this.children; _i < _b.length; _i++) {
            var child = _b[_i];
            child.toggleSelfAndDescendants(value);
        }
    };
    return PhoenixMenuNode;
}());
export { PhoenixMenuNode };
//# sourceMappingURL=phoenix-menu-node.js.map